import {
  TLBaseShape,
  RecordProps,
  T,
  HTMLContainer,
  BaseBoxShapeUtil,
  BoundsSnapGeometry,
  Rectangle2d,
} from "@tldraw/tldraw";

type DoorHangerUtilType = TLBaseShape<
  "doorHanger",
  {
    w: number;
    h: number;
    fill?: string;
  }
>;

export class DoorHangerUtil extends BaseBoxShapeUtil<DoorHangerUtilType> {
  static type = "doorHanger" as const;
  static props: RecordProps<DoorHangerUtilType> = {
    w: T.number,
    h: T.number,
    fill: T.optional(T.string),
  };
  mm = 5;

  isAspectRatioLocked(_shape: DoorHangerUtilType): boolean {
    return true;
  }

  getDefaultProps(): { w: number; h: number; fill?: string } {
    return {
      w: 0,
      h: 0,
      fill: "#ffffff",
    };
  }

  getBoundsSnapGeometry(shape: DoorHangerUtilType): BoundsSnapGeometry {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
      x: 0,
      y: 0,
    });
  }

  component(shape: DoorHangerUtilType) {
    return (
      <HTMLContainer
        id={shape.id}
        style={{ backgroundColor: shape.props.fill, width: shape.props.w, height: shape.props.h }}
        className="relative flex items-center justify-center"
      >
        <svg width="240" height="560" viewBox="-1 -1 242 562" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            strokeWidth="1"
            strokeDasharray={"4 4"}
            d="M15.6445 100.222C10.5948 102.897 5.85542 105.995 1.39899 109.411C1.06053 109.671 0.863098 110.067 0.863098 110.486V561L240 561V1H0.863098V64.6554C0.863098 65.0675 1.05395 65.4577 1.38395 65.7175C5.83379 69.2311 9.72521 73.3409 14.7815 76.0158C22.7222 80.2196 31.9396 82.8899 41.047 85.0132C41.1035 85.0269 41.1599 85.0369 41.2172 85.0424C42.8108 85.2183 44.348 85.4709 46.0149 85.696C47.6443 85.9167 49.3309 86.0999 51.042 86.0999M15.6022 100.245C23.6116 95.648 31.98 92.4717 41.0461 90.3547C41.0546 90.3529 41.063 90.3511 41.0715 90.3493C44.3809 89.6382 47.6687 89.2762 50.886 88.9307C54.2151 88.5733 57.5339 88.5733 60.8621 88.9307M60.8349 88.9279C69.1235 89.6564 76.2424 93.6851 81.4585 99.4834C81.514 99.5454 81.5638 99.612 81.6071 99.6822C82.6206 101.328 83.9857 102.996 85.4336 104.74C85.475 104.789 85.5126 104.842 85.5464 104.897C86.5543 106.534 87.9091 108.185 89.2686 109.495C89.3203 109.546 89.3673 109.599 89.4115 109.656C94.2515 116.041 100.81 120.727 108.73 123.07C108.735 123.071 108.74 123.073 108.746 123.075C116.346 125.423 124.639 125.423 132.23 123.075C132.235 123.073 132.241 123.071 132.247 123.07C140.144 120.735 146.703 115.723 151.575 109.309C156.401 102.943 158.822 95.5814 158.822 87.5112C158.822 79.7792 156.405 72.0719 151.575 65.7129C146.735 59.3302 140.165 54.6278 132.194 51.9365M132.23 51.9474C124.629 49.5999 116.336 49.5999 108.747 51.9474C108.74 51.9493 108.735 51.9511 108.729 51.9529C100.801 54.296 94.2524 58.9811 89.4115 65.3665C89.4002 65.3802 89.3898 65.3948 89.3776 65.4075C87.8197 67.3066 86.5637 68.4954 85.5417 70.1328C85.5107 70.1829 85.4759 70.2303 85.4392 70.2768C83.9923 72.0382 82.6197 73.7038 81.6052 75.343C81.5695 75.4005 81.53 75.4551 81.4858 75.508C76.2321 81.7111 69.0934 85.3423 60.8988 86.4336C60.8358 86.4427 60.771 86.4464 60.707 86.4464C57.4945 86.4464 54.202 86.4482 50.886 86.0918"
            stroke="#FF0000"
          />
        </svg>
      </HTMLContainer>
    );
  }
  indicator(shape: DoorHangerUtilType) {
    return this.component(shape);
  }
}
